<template>
    <div class="PubCustom-select-Container" :class="{ 'is-flat': flat, 'is-disabled': disabled }" ref="PubCustomSelect">
      <div class="PubCustom-select-Title">
        <a
          href="javascript:;"
          :class="{ 'is-disabled': disabled }"
          @click="ShowDownMethod"
          v-bind:t_label="'EMPBE_ProductInfo_Header_ShowDown'"
        >
          <div class="PubCustom-select" :class="{ 'is-flat': flat, 'is-disabled': disabled }">
            <div class="PubCustom-select-Tigger">
              <slot name="HeadTitle"></slot>
            </div>
            <div class="PubCustom-select-Arrow" v-show="LiList.length>0">
              <img
                :src="flat ? expandMoreIcon : ProductInfoCdnURL + 'ArrowDrop .svg'"
                :alt="flat ? '' : 'expand'"
              >
            </div>
          </div>
        </a>
      </div>
       <div class="PubCustom-select-Dropdown" v-if="ShowDown" v-show="LiList.length>0">
        <!-- //[index==0? 'borderTop' : '',  -->
          <ul > 
            <li v-if="fromAdmin" :key="0" :class="LiList[0].disabled ? 'isDisabled' : ''" >
              <a href="javascript:;" 
              v-bind:t_label="'EMPBE_ProductInfo_Header_'+LiList[0].eventName"   
              @click="ReturnParentEmit(LiList[0])" class="blackText">
                <i v-if="LiList[0].iconClass" :class="LiList[0].iconClass"></i>
                <span>{{LiList[0].name}}</span>
              </a>
            </li>
            <li class="liBr" v-if="fromAdmin"></li>
            <li  v-for="(item,index) in newLiList" :key="index" :class="item.disabled ? 'isDisabled' : ''" >
              <a href="javascript:;" :class="[item.status==0?'blackText':'redText', item.disabled ? 'disabledText' : '']" 
              v-bind:t_label="'EMPBE_ProductInfo_Header_'+item.eventName"   
              @click="ReturnParentEmit(item)">
                <i v-if="item.iconClass" :class="item.iconClass"></i>
                <span>{{item.name}}</span>
              </a>
            </li>
            
          </ul>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props:{
      LiList:{
        type:Array,
        default:()=>[
          {name:"Delist",eventName:"Delist",status:0},
          {name:"Delete",eventName:"Delete",status:1},
        ] 
    },
      /** Figma PanelBtn：整钮一体背景 + expand_more 图标（无独立边框箭头） */
      flat: {
        type: Boolean,
        default: false,
      },
       fromAdmin:{type:Boolean,default: false},
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data(){
        return {
          ProductInfoCdnURL:"https://cdn.adsalecdn.com/EMP/Backend/svg/ProductInfo/",
          expandMoreIcon: require('@/assets/images/icon-expand-more.svg'),
          ShowDown:false
        }
    },
    mounted() { 
      document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside);
    },
    watch:{
     
    },
    computed:{
      newLiList(){
        if(this.fromAdmin)
        {
          return this.LiList.slice(1);
        }else{
          return this.LiList;
        }

      }
    },
    methods:{
      ShowDownMethod(){
        if (this.disabled) return;
        this.ShowDown = !this.ShowDown
      },
      ReturnParentEmit(item){
        if (item.disabled) {
          return;
        }
        this.ShowDown = false;
        this.$emit('ResultClick',item)
      },
      handleClickOutside(event) {
      if (!this.$refs.PubCustomSelect.contains(event.target)) 
      {
        this.ShowDown = false;
      }
    }
    }
  }
  </script>
<style lang="scss" scoped>
.PubCustom-select-Title{
  width: 100%;
}
.PubCustom-select-Container{
  position: relative;
  z-index: 2;
}
.PubCustom-select-Dropdown
{
  position: absolute;
  // width: 100%;
  text-align: center;
  margin-top: 2px;
  right:0px;
  white-space: nowrap;
  ul{
    
    background: #FFF;
    border-radius: 8px;
    border: 1px solid var(--outline-10, rgba(0, 0, 0, 0.10));
    li
    {
      display: flex;
      align-items: center;
      gap: 10px;
      align-self: stretch;
      height: 40px;
      min-width: 130px;
      a
      {
        padding: 8px 16px;
        width: 100%;
        text-align: left;
        display: inline-flex;
        align-items: center;
        gap: 8px;
      }
      .disabledText {
        color: rgba(0, 0, 0, 0.35) !important;
        cursor: not-allowed;
      }
      .redText
      {
        color: var(--Error-Light, #DC3545);
      }
      .blackText
      {
        color: var(--on-surface-80, rgba(0, 0, 0, 0.80))
      }
    }
    li:hover
    {
    background: rgba(0, 0, 0, 0.03);
    }
  }
  .borderTop
  {
    border-top: 1px solid var(--outline-10, rgba(0, 0, 0, 0.10));
  }
  .liBr{
    height: 0; 
    margin: 2px 0;
    border-top: 1px solid var(--outline-10, rgba(0, 0, 0, .1));
  }
  .isDisabled {
    background: rgba(0, 0, 0, 0.01);
  }
 
}
 .PubCustom-select{
  display: flex;
  align-items: flex-start;
  gap: 4px;
 }
 .PubCustom-select.is-flat {
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  width: auto;
  min-width: 0;
  height: 36px;
  padding: 0 8px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.03);
  box-sizing: border-box;
 }
 .PubCustom-select-Tigger{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  border-radius: 3px;
  overflow: hidden;
  color: #FFF;
  text-align: center;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: -0.154px;
 }
 .PubCustom-select.is-flat .PubCustom-select-Tigger {
  color: rgba(0, 0, 0, 0.8);
  gap: 0;
  overflow: visible;
 }
 .PubCustom-select-Arrow
 {
  display: flex;
  width: 34px;
  padding: 7px 6px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: 1px solid var(--outline-10, rgba(0, 0, 0, 0.10));
  background: #FFF;
 }
 .PubCustom-select.is-flat .PubCustom-select-Arrow {
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 0;
  flex-shrink: 0;
 }
 .PubCustom-select.is-flat .PubCustom-select-Arrow img {
  width: 10px;
  height: 6px;
  display: block;
 }
.PubCustom-select-Container.is-disabled .PubCustom-select.is-flat,
.PubCustom-select.is-flat.is-disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}
.PubCustom-select-Title > a.is-disabled {
  cursor: not-allowed;
  pointer-events: none;
}
 .graybg{
 color: rgba(0, 0, 0, 0.40)
 }
</style>